// src/components/Typewriter.js

import React from 'react';

const Typewriter = ({ text }) => {
  // This component simply renders the text it's given and adds a cursor.
  // The streaming effect is created by the parent component re-rendering it with new text.
  return (
    <span>
      {text}
      <span className="blinking-cursor">█</span>
    </span>
  );
};

export default Typewriter;